//import html2canvas from 'html2canvas'
import {
  firebase,
  db,
  auth,
  createCustomerSetTokenSubscribe,
  removeClient,
  processCouponDealCode,
  customSubscribe,
  inviteViaText,
  inviteViaEmail,
  removeMultiLocation,
  buildWidget
} from '../../firebase/firebaseConfig.js'
import axios from 'axios'
import {
  checkIsTrialOver
} from '../../methods/checkIsTrialOver.js'

// Backend-URL target. Three modes:
//   - "prod"     : default for production builds. Hits feedback.link.
//   - "localhost": default for `npm run serve` (NODE_ENV=development).
//                  Hits localhost Cloud Run services on assorted ports.
//   - "devcloud" : opt-in via VUE_APP_BACKEND_TARGET=devcloud. Redirects ONLY
//                  the reviewsAndShowcase service to its dev Cloud Run URL
//                  (https://reviews-134361153501.us-central1.run.app). The
//                  `dashboard` and `fetchnps` Cloud Run services are NOT
//                  deployed to the dev project, so dashURLBase + npsApiURL
//                  stay at localhost — run those locally if you need them.
//                  See Dashboard App/CLAUDE.md "Dev environment modes".
const backendTarget = process.env.VUE_APP_BACKEND_TARGET ||
  (process.env.NODE_ENV === 'development' ? 'localhost' : 'prod')

const DEV_REVIEWS_CLOUD_RUN = 'https://reviews-134361153501.us-central1.run.app'

let dashURLBase = 'https://feedback.link'
let npsApiURL = 'https://feedback.link/api/fetchnps'
let markShowcaseURL = 'https://feedback.link/api/markforshowcase'
let checkProfileURL = 'https://feedback.link/api/addprofile'
let fetchShowcaseDataURL = 'https://feedback.link/api/fetchshowcasedata'
let fetchShowcasedItemsURL = 'https://feedback.link/api/fetchshowcaseditems'
let deleteVideoTestimonialURL = 'https://feedback.link/api/deletevideotestimonial'

if (backendTarget === 'localhost') {
  npsApiURL = 'http://localhost:2030'
  fetchShowcaseDataURL = 'http://localhost:1053/api/fetchshowcasedata'
  fetchShowcasedItemsURL = 'http://localhost:1053/api/fetchshowcaseditems'
  markShowcaseURL = 'http://localhost:1053/api/markforshowcase'
  checkProfileURL = 'http://localhost:1053/api/addprofile'
  deleteVideoTestimonialURL = 'http://localhost:1053/api/deletevideotestimonial'
  dashURLBase = 'http://localhost:1000'
} else if (backendTarget === 'devcloud') {
  fetchShowcaseDataURL = `${DEV_REVIEWS_CLOUD_RUN}/api/fetchshowcasedata`
  fetchShowcasedItemsURL = `${DEV_REVIEWS_CLOUD_RUN}/api/fetchshowcaseditems`
  markShowcaseURL = `${DEV_REVIEWS_CLOUD_RUN}/api/markforshowcase`
  checkProfileURL = `${DEV_REVIEWS_CLOUD_RUN}/api/addprofile`
  deleteVideoTestimonialURL = `${DEV_REVIEWS_CLOUD_RUN}/api/deletevideotestimonial`
  npsApiURL = 'http://localhost:2030'
  dashURLBase = 'http://localhost:1000'
}

let storageRef = firebase.storage().ref()

//Crypto hash for generating unique ids
String.prototype.hashCode = function() {
  var hash = 0,
    i, chr
  if (this.length === 0) return hash
  for (i = 0; i < this.length; i++) {
    chr = this.charCodeAt(i)
    hash = ((hash << 5) - hash) + chr
    hash |= 0 // Convert to 32bit integer
  }
  return hash
}

function randomDateBeforeDays(start, days) {
  return new Date(start.getTime() - Math.round(Math.random() * days * 24 * 60 * 60 * 1000))
}

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

function timeConverter(UNIX_timestamp) {
  var a = new Date(UNIX_timestamp * 1000);
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
  return time;
}

function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(dataURI.split(',')[1]);
  else
    byteString = unescape(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], {
    type: mimeString
  });
}

let lastSnapDoc = {}

export default {
  'PROCESS_DEAL_ADDON_CODE' ({commit, state}, payload) {

    return new Promise((resolve, reject) => {
      return processCouponDealCode({
        bID: state.viewData.business.businessID,
        code: payload.code,
        type: payload.type
      }).then((res) => {
        resolve(res)
      }).catch((rej) => {
        //noconsoleconsole.log('error from BE:')
        //noconsoleconsole.log(rej)
        reject(rej)
      })

    });

  },
  'SYNC_SIGNUP' ({
    commit,
    state
  }, payload) {

    let newDoc = db.collection('signupsyncs').doc(payload)

    let signupRecordedAppearance = { ...state.signUpState.recorded.appearance
    }
    let signupRecordedBI = { ...state.signUpState.recorded.businessInfo
    }
    let signupRecordedFB = state.signUpState.recorded.socialMedia.facebook
    let signupRecordedTW = state.signUpState.recorded.socialMedia.twitter
    let signupRecordedGM = ''

    if (state.signUpState.recorded.socialMedia.googleMaps !== '') {
      let placeID = state.signUpState.recorded.socialMedia.googleMaps.place_id
      signupRecordedGM = placeID
    }

    return newDoc.set({
      appearance: signupRecordedAppearance,
      businessInfo: signupRecordedBI,
      facebook: signupRecordedFB,
      twitter: signupRecordedTW,
      googlemaps: signupRecordedGM
    })

  },
  'SCHEDULE_WIDGETS_BUILD' ({
    commit,
    state,
    dispatch
  }) {
    
    //build all widgets after a minute
    const currentWidgets = state.viewData.currentWidgets.map((w) => w.widgetID)

    if (currentWidgets.length == 0) return

    commit('SET_BUILD_WIDGETS_TIMEOUT', 
      setTimeout(() => {    
        dispatch('BUILD_WIDGET', currentWidgets)
        commit('SET_BUILD_WIDGETS_TIMEOUT', false)
      }, 15000)
    )

  },
  'BUILD_WIDGET' ({
    commit,
    state
  }, payload) {

    //noconsoleconsole.log('subscribing with payload:')
    //noconsoleconsole.log(payload)

    return new Promise((resolve, reject) => {

      commit('SET_BUILD_WIDGETS_TIMEOUT', true)

      if (payload.length === 0) {
        resolve()
        return
      }

      return buildWidget({
        wIDs: payload,
        bID: state.viewData.business.businessID        
      }).then((res) => {
        resolve(res)
        commit('SET_BUILD_WIDGETS_TIMEOUT', false)
      }).catch((rej) => {
        //noconsoleconsole.log('error from BE:')
        //noconsoleconsole.log(rej)
        commit('SET_BUILD_WIDGETS_TIMEOUT', false)
        reject(rej)
      })

    });
  }, 
  'FETCH_SHOWCASED_IDs' ({
    state,
    commit
  }) {

    //initial call to get ids and tags of all items currently on showcase

    console.log('loading initial showcase')
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(fetchShowcaseDataURL, {
          bID: state.viewData.business.businessID
        }, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          let dta = res.data
          //noconsoleconsole.log(dta)
          console.log('initial showcase loaded')
          console.log(dta)
  
          commit('SYNC_INITIAL_SHOWCASED_IDs', dta.data)
  
          resolve()
        }).catch((res) => {
          console.log(res)
          reject()
        })
      }).catch((e) => {
        console.log(e)
        reject()
      })
    })

  
  },   
  'START_VIDEO_TRIAL' ({
    state
  }, payload) {

  return new Promise((resolve, reject) => {
    const bePayload = {
      bid: state.viewData.business.businessID      
    }

    auth.currentUser.getIdToken().then((token) => {
      axios.post(dashURLBase + '/api/dash/startvideotrial', bePayload, {
        headers: {
          token: token,
          'Content-Type': 'application/json'
        }
      }).then((res) => {        
        resolve(res.data)
      }).catch((e) => {
        reject()
      })
    })
  })    

  },
  'UPDATE_WIDGET' ({
    state
  }, payload) {

  return new Promise((resolve, reject) => {

    const bePayload = {
      bid: state.viewData.business.businessID,      
      uiData: payload.uiData,
      widgetID: payload.widgetID,
      remove: false
    }

    auth.currentUser.getIdToken().then((token) => {
      axios.post(dashURLBase + '/api/dash/updateremovewidget', bePayload, {
        headers: {
          token: token,
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        
        resolve(res.data)

      }).catch((e) => {

        reject()

      })
    })

  })    

  },
  'UPDATE_DOMAIN_SETTINGS' ({
    state
  }, payload) {

  return new Promise((resolve, reject) => {

    const bePayload = {
      bid: state.viewData.business.businessID,
      domainSettings: {...payload}
    }

    auth.currentUser.getIdToken().then((token) => {
      axios.post(dashURLBase + '/api/dash/updatedomainsettings', bePayload, {
        headers: {
          token: token,
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        
        resolve(res.data)

      }).catch((e) => {

        reject()

      })
    })

  })    

  },
  'REMOVE_WIDGET' ({
    state
  }, payload) {

  return new Promise((resolve, reject) => {

    const bePayload = {
      bid: state.viewData.business.businessID,
      widgetID: payload,
      remove: true
    }

    auth.currentUser.getIdToken().then((token) => {
      axios.post(dashURLBase + '/api/dash/updateremovewidget', bePayload, {
        headers: {
          token: token,
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        
        resolve()

      }).catch((e) => {

        reject()

      })
    })

  })    

  }, 
  'CREATE_WIDGET' ({
    state
  }, payload) {

  return new Promise((resolve, reject) => {

    const bePayload = {
      bid: state.viewData.business.businessID,      
      uiData: payload
    }

    auth.currentUser.getIdToken().then((token) => {
      axios.post(dashURLBase + '/api/dash/addwidget', bePayload, {
        headers: {
          token: token,
          'Content-Type': 'application/json'
        }
      }).then((res) => {        
        resolve(res.data)
      }).catch((e) => {
        reject()
      })
    })

  })    

  },
  'SYNC_WIDGETS' ({
    commit,
    state
  }) {    
    
    return new Promise((resolve, reject) => {

      console.log('loading initial widgets')
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/fetchentitywidgets', {
          bid: state.viewData.business.businessID
        }, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {                     
          console.log('syncing initial widgets')
          commit('SYNC_WIDGETS', {data: res.data})

          resolve()
  
        }).catch((e) => {
  
          reject()
  
        })
      })


    })

  },
  'TOGGLE_MARK_SHOWCASE' ({
    commit,
    state,
    dispatch
  }, payload) {

    //this is both for marking feedback AND reviews

    //fetch the data of the session
    
    return new Promise((resolve, reject) => {

      let bePayload = {
        bID: state.viewData.business.businessID,
        platform: payload.platform,
        intent: payload.intent,
        tag: payload.tag,
        currentTags: payload.currentTags
      }      

      if (payload.platform !== 'feedback' && payload.platform !== 'testimonial') {
        //rvw
        bePayload.reviewDocID = state.viewData.business.externalPlatforms[payload.platform].luID,
        bePayload.type = 'review'
        bePayload.seshData = {...state.viewData.reviews[payload.platform].reviews[payload.i]}
        bePayload.docID = bePayload.seshData.unique_id        
      } else {
        //fdback or test.
        bePayload.sessionID = payload.sessionID
        bePayload.type = payload.platform
        bePayload.i = payload.i
        bePayload.seshData = state.viewData.viewFeedback.find(itm => itm.sessionID === payload.sessionID)        
      }

      console.log(bePayload)

      //noconsoleconsole.log(bePayload)

      auth.currentUser.getIdToken().then((token) => {
        axios.post(markShowcaseURL, bePayload, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {

          let dta = res.data
          //noconsoleconsole.log(dta)

          dispatch('SCHEDULE_WIDGETS_BUILD') 

          resolve(dta)

        }).catch((res) => {
          //noconsoleconsole.log(res)


          reject()
        })
      }).catch((e) => {
        //noconsoleconsole.log(e)
        reject()
      })

    })

  },
  'DELETE_VIDEO_TESTIMONIAL' ({
    state,
    dispatch
  }, payload) {

    // PERMANENTLY deletes a video testimonial: R2 objects, the videos driver doc,
    // the video fields on the public feedback answer, and the showcased copy.
    // payload = { sessionID, jFI, streamUID }

    return new Promise((resolve, reject) => {

      let bePayload = {
        bID: state.viewData.business.businessID,
        sessionID: payload.sessionID,
        jFI: payload.jFI,
        streamUID: payload.streamUID
      }

      auth.currentUser.getIdToken().then((token) => {
        axios.post(deleteVideoTestimonialURL, bePayload, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {

          // rebuild any widgets that were showing this video
          dispatch('SCHEDULE_WIDGETS_BUILD')

          resolve(res.data)

        }).catch((res) => {
          reject(res)
        })
      }).catch((e) => {
        reject(e)
      })

    })

  },
  'FETCH_SHOWCASED_ITEMS' ({
    state,
    commit
  }) {

    return new Promise((resolve, reject) => {

      auth.currentUser.getIdToken().then((token) => {
        axios.post(fetchShowcasedItemsURL, {
          bID: state.viewData.business.businessID
        }, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          const items = (res.data && Array.isArray(res.data.items)) ? res.data.items : []
          commit('SET_SHOWCASED_ITEMS', items)
          resolve(items)
        }).catch((e) => {
          console.log(e)
          reject(e)
        })
      }).catch((e) => {
        console.log(e)
        reject(e)
      })

    })

  },
  'TOGGLE_MARK_SHOWCASE_FROM_TAB' ({
    commit,
    state,
    dispatch
  }, payload) {

    // Used by the Showcased tab on /dash/showcase, where we operate against
    // already-showcased docs (hydrated via FETCH_SHOWCASED_ITEMS). Unlike
    // TOGGLE_MARK_SHOWCASE we don't look up seshData in viewData.reviews —
    // there's no source row to look up (extension-captured items in
    // particular have no source). The backend's delete and tag-edit paths
    // don't read seshData; we pass a stub purely to satisfy validation.

    return new Promise((resolve, reject) => {

      const item = payload.item
      const isFeedbackTesto = item.platform === 'feedback' || item.platform === 'testimonial'

      let bePayload = {
        bID: state.viewData.business.businessID,
        platform: item.platform,
        intent: payload.intent,
        tag: payload.tag,
        currentTags: payload.currentTags,
        seshData: item.data || {}
      }

      if (isFeedbackTesto) {
        const lastUnderscore = item.id.lastIndexOf('_')
        bePayload.sessionID = lastUnderscore > -1 ? item.id.slice(0, lastUnderscore) : item.id
        bePayload.i = lastUnderscore > -1 ? Number(item.id.slice(lastUnderscore + 1)) : 0
        bePayload.type = item.platform
      } else {
        bePayload.type = 'review'
        bePayload.docID = item.id
        bePayload.reviewDocID = item.id
      }

      auth.currentUser.getIdToken().then((token) => {
        axios.post(markShowcaseURL, bePayload, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {

          dispatch('SCHEDULE_WIDGETS_BUILD')
          resolve(res.data)

        }).catch((e) => {
          console.log(e)
          reject(e)
        })
      }).catch((e) => {
        console.log(e)
        reject(e)
      })

    })

  },
  'UPDATE_SHOWCASE_SETTINGS' ({
    state
  }, payload) {
    return new Promise((resolve, reject) => {

      db.collection('entities').doc(state.viewData.business.businessID).update({
        'showcase.widgetFrequency': payload.frequency,
        'showcase.widgetPosition': payload.position,
        'showcase.autoShowcaseReviews': payload.autoShowcaseReviews,
      }).then(() => {
        resolve()
      }).catch((e) => {
        reject()
      })

    })
  },
  'ADD_PROFILE_FOR_REVIEWS_SCRAPE' ({
    commit,
    state,
    dispatch
  }, payload) {

    /*
    payload:
      {
        id: ..
        platform: ..
      }
    */

    //return

    return new Promise((resolve, reject) => {

      let reqBody = {
        businessID: state.viewData.business.businessID,
        profileURLOrID: payload.id,
        platform: payload.platform
      }

      auth.currentUser.getIdToken().then((token) => {
        axios.post(checkProfileURL, reqBody, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          //noconsoleconsole.log(res)
          resolve()
        }).catch((res) => {
          //noconsoleconsole.log(res)
          reject()
        })
      }).catch((e) => {
        //noconsoleconsole.log(e)
        reject()
      })
    })

  },
  'INITIATE_TEXT_CREDITS_ADDON' ({
    commit,
    state
  }, payload) {
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(`${dashURLBase  }/api/dash/initiatebuytextcredits`, {
          bID: state.viewData.business.businessID,
          numberOfCredits: payload.numberOfCredits,
          customerEmail: payload.customerEmail
        }, {
          headers: {
            token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
        //noconsole.log('colb')
          resolve(res.data)
        }).catch((res) => {
        //noconsole.log(res)
          reject()
        })
      }).catch((e) => {
      //noconsole.log(e)
        reject()
      })
    })
  },
  'INITIATE_VIDEO_LTD_PURCHASE' ({
    commit,
    state
  }, payload) {
    return new Promise((resolve, reject) => {
      console.log(payload)
      auth.currentUser.getIdToken().then((token) => {
        axios.post(`${dashURLBase  }/api/dash/initiatebuyvideoaddon`, {
          bID: state.viewData.business.businessID,
          customerEmail: payload.customerEmail
        }, {
          headers: {
            token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
        //noconsole.log('colb')
          resolve(res.data)
        }).catch((res) => {
        //noconsole.log(res)
          reject()
        })
      }).catch((e) => {
      //noconsole.log(e)
        reject()
      })
    })
  },
  'LOAD_REVIEWS' ({
    commit,
    state,
    dispatch
  }, payload) {

    const isReset = typeof payload.reset !== 'undefined'

    return new Promise((resolve, reject) => {
      const platform = payload.platform
      const startAt = isReset ? 0 : state.viewData.reviews[platform].currentThreshold - 50
      const endAt = isReset ? 50 : state.viewData.reviews[platform].currentThreshold
      //noconsoleconsole.log(state.viewData.business.externalPlatforms[platform].luID)

      let query
      if (state.viewData.reviews[platform].reviews.length === 0 || isReset) {
        query = db.collection('reviews').doc(state.viewData.business.externalPlatforms[platform].luID).collection('allreviews').orderBy('date', 'desc').limit(50)
      } else {
        query = db.collection('reviews').doc(state.viewData.business.externalPlatforms[platform].luID).collection('allreviews').orderBy('date', 'desc').startAfter(lastSnapDoc[platform]).limit(50)
      }

      commit('TOGGLE_REVIEWS_LOADING', {
        value: true,
        platform
      })

      return query.get().then((snap) => {

        const reviews = []
        //noconsoleconsole.log(snap.docs)
        if (snap.docs.length > 0) {
          snap.docs.forEach((doc, i) => {
            const docData = doc.data()
            //inject the loaded prperty for reactive view
            docData.loaded = false
            docData.reviewDocID = doc.id                                  

            reviews.push(docData)
            if (i === 49) {
              lastSnapDoc[platform] = doc
            }
          })
        }        

        if (isReset && typeof payload.notify !== 'undefined') {

          let pfString = ''
        switch (platform) {
        case 'gp':
          pfString = 'Google'
          break
        case 'ca':
          pfString = 'Capterra'
          break
        case 'fs':
          pfString = 'Foursquare'
          break
        case 'fb':
          pfString = 'Facebook'
          break
        case 'g2':
          pfString = 'G2'
          break
        case 'ta':
          pfString = 'Tripadvisor'
          break
        case 'tp':
          pfString = 'Trustpilot'
          break
        case 'ye':
          pfString = 'Yelp'
          break
        }
          
          payload.notify({
            title: 'Reviews updated',
            text: `Your ${  pfString  } reviews have been imported!`,
            color: 'success',
            time: 15000,
            iconPack: 'feather',
            icon: 'icon-check'
          })
        }

        console.log(`${platform} reviews fetched`)

        commit('POPULATE_REVIEWS', {
          platform,
          reviews,
          isReset
        })
        commit('TOGGLE_REVIEWS_LOADING', {
          value: false,
          platform
        })
        resolve()


      }).catch((e) => {
        //noconsoleconsole.log(e)
      })
    })

  },
  'CHECK_NEW_REVIEWS' ({
    commit,
    state,
    dispatch
  }, payload) {

    return new Promise((resolve, reject) => {

      /*
      if (typeof data.businessID === 'undefined') throw "nogameid"
      if (typeof data.profileURLOrID === 'undefined') throw "nogameid"
      if (typeof data.platform === 'undefined') throw "nogameid"
      */

      //add a onSnapshot to listen for new reviews
      //the on snapshot refresher calls this action, but with a reset flag
      let hasBeenCalled = false
      let isFirstTime = true
      db.collection('reviews').doc(state.viewData.business.externalPlatforms[payload.platform].luID).collection('allreviews').orderBy('date', 'desc').limit(1).onSnapshot((docs) => {
        //noconsoleconsole.log(docs)
        //noconsoleconsole.log('snapshot set')
        if (!hasBeenCalled && !isFirstTime) {
          //this hasBeenCalled flag is just incase someone mark a review for showcase, which will trigger the onsnapshot
          dispatch('LOAD_REVIEWS', {
            ...payload,
            reset: true
          })
          hasBeenCalled = true
        }
        isFirstTime = false
      })

      let reqBody = {
        businessID: state.viewData.business.businessID,
        profileURLOrID: state.viewData.business.externalPlatforms[payload.platform].id,
        platform: payload.platform
      }

      auth.currentUser.getIdToken().then((token) => {
        axios.post(checkProfileURL, reqBody, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          resolve()
        }).catch((res) => {
          //noconsoleconsole.log(res)
          reject()
        })
      }).catch((e) => {
        //noconsoleconsole.log(e)
        reject()
      })

    });

  },
  'CUSTOM_SUBSCRIPTION' ({
    commit,
    state
  }, payload) {


    return new Promise((resolve, reject) => {

      return customSubscribe(payload).then((res) => {
        resolve(res)
      }).catch((rej) => {
        //noconsoleconsole.log('error from BE:')
        //noconsoleconsole.log(rej)
        reject(rej)
      })

    });
  },
  'SEND_SUPPORT_MESSAGE' ({
    commit,
    state
  }, payload) {

    return new Promise((resolve, reject) => {

      let newDoc = db.collection('supportmessages')

      newDoc.add({
        businessName: state.viewData.business.businessName,
        fromEmail: state.loggedInUser.emailAddress,
        message: payload
      }).then(() => {
        resolve()
      }).catch(() => {
        reject()
      })

    })
  },
  'REMOVE_COLLABORATOR' ( {
    commit,
    state
  }, payload ) {
    return new Promise((resolve, reject) => {
    auth.currentUser.getIdToken().then((token) => {
      axios.post(dashURLBase + '/api/dash/removecollaborator', {
        bID: state.viewData.business.businessID,
        email: payload.email.trim()
      }, {
        headers: {
          token: token,
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        //noconsole.log('colb')
        resolve(res.data)
      }).catch((res) => {
        //noconsole.log(res)
        reject()
      })
    }).catch((e) => {
      //noconsole.log(e)
      reject()
    })
    })
  },
  'ADD_COLLABORATOR' ( {
    commit,
    state
  }, payload ) {
    return new Promise((resolve, reject) => {
    auth.currentUser.getIdToken().then((token) => {
      axios.post(dashURLBase + '/api/dash/addcollaborator', {
        bID: state.viewData.business.businessID,
        email: payload.email.trim(),
        name: payload.name.trim(),
        inviterName: payload.inviterName.trim(),
        businessName: state.viewData.business.businessName,
        resend: typeof payload.resend !== "undefined"
      }, {
        headers: {
          token: token,
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        //noconsole.log('colb')
        resolve(res.data)
      }).catch((res) => {
        //noconsole.log(res)
        reject()
      })
    }).catch((e) => {
      //noconsole.log(e)
      reject()
    })
    })
  },
  'UPDATE_NOTIFICATIONS' ( {
    commit,
    state
  }, payload ) {
    return new Promise((resolve, reject) => {
    auth.currentUser.getIdToken().then((token) => {
      axios.post(dashURLBase + '/api/dash/updatenotificationsettings', {
        notificationSettings: payload.notificationSettings,
        receiveUpdates: payload.receiveUpdates
      }, {
        headers: {
          token: token,
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        //noconsole.log('colb')
        resolve(res.data)
      }).catch((res) => {
        //noconsole.log(res)
        reject()
      })
    }).catch((e) => {
      //noconsole.log(e)
      reject()
    })
    })
  },
  'LIST_NOTIFICATIONS' (
    {
      commit,
      state
    }, payload ) {
      return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/getnotificationsettings', {}, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          //noconsoleconsole.log('notf. settings fetched')
          resolve(res.data)
        }).catch((res) => {
          //noconsoleconsole.log(res)
          reject()
        })
      }).catch((e) => {
        //noconsole.log(e)
        reject()
      })
    })
  },
  'I_HAVE_LOGGED_IN' (
    {
      state
    } ) {
      return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/ihaveloggedin', {
          bID: state.viewData.business.businessID
        }, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          //noconsoleconsole.log('colbs fetched')
          resolve(res.data)
        }).catch((res) => {
          //noconsole.log(res)
          reject()
        })
      }).catch((e) => {
        //noconsole.log(e)
        reject()
      })
    })
  },
  'LIST_COLLABORATORS' (
    {
      commit,
      state
    }, payload ) {

      return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/getcollaborators', {
          bID: state.viewData.business.businessID
        }, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          //noconsoleconsole.log('colbs fetched')
          resolve(res.data)
        }).catch((res) => {
          //noconsole.log(res)
          reject()
        })
      }).catch((e) => {
        //noconsole.log(e)
        reject()
      })
    })

  },
  'LOGIN_GET_ACCESS' ({
    commit,
    state
  }, payload) {


    return new Promise((resolve, reject) => {

     
      //this action checks for a UIDToENTITY doc for this uid

      db.collection('uidtoentityid').doc(payload.user.uid).get().then((doc) => {
              
        if (doc.exists) {
      
          //Feedback Link admin ovverride
          //the backend will allow this.
          if (doc.id === 'oVeXS38MBLNB3RYIsGCwM3QMtZM2') {             
          
            if (payload.viewBusiness) {
            commit('SET_LOGIN_USER', {
              authID: payload.user.uid,
              firstName: '',
              lastName: '',
              contactNumber: '',
              emailAddress: '',
              lastAccessed: false,
              entityDocID: payload.viewBusiness,
              firstName: '',
              lastName: '',
              clientNameIfAgencyClient: false,
              agency: false,
              agencySplit: false,
              agencyBaseDomain: false,
              clientAuthDoc: false,
              agencyEntityDocID: false,
              agencySubscription: false,
              agencyName: false,
              lastAccessed: false,
              isCollaborator: false,
              timeSignedUp: false
            })
            resolve(true)
            return
          }

        }

          const data = doc.data()          

          //package the normal login in a var:

          let continueLogin = (collaborator) => {

                        
            let agency = false
            let agencyClients = false

            //init the initial uidData to load. This may be changed below...
            let uidDataToInit = data            

            //is this an agency???
            if (typeof data.agency !== 'undefined' && !collaborator) {
              
              //(you cant be an agency AND a collaborator)
            
              agency = true

              if (typeof data.agencyClients !== 'undefined') {
                agencyClients = data.agencyClients                
              } else {
                agencyClients = []
              }                

              if (payload.viewBusiness || payload.agencyC) {
                            
                //look for a specific entity and load that client
                //noconsoleconsole.log('this is agency client, looping through client eIDs')                
                  
                //will be set when agency wants to view a specific client and load all
                //of it's locations                                
                
                if (agency) {

                //this is agency wanting to view client entity, look for the entity in agency doc:

                //really bad code:
                agencyClients.forEach((client, i) => {

                  if (client.clientID === payload.agencyC) {

                      uidDataToInit = client

                  } else {
                    if (Array.isArray(client.entityDocID)) {
                                          
                      client.entityDocID.forEach((bid, i) => {                      

                        if (bid === payload.viewBusiness) {
                          //noconsoleconsole.log('found it')
                          uidDataToInit = client
                        }

                      })
                    } else {
                      
                      if (client.entityDocID === payload.viewBusiness) {
                        //noconsoleconsole.log('found it')
                        uidDataToInit = client
                      }

                    }
                  }

                   
                  })

                }         

                }               
                                        
            }
            
          

            //check if dash needs branding
            let branding = false
            if (typeof uidDataToInit.branding !== 'undefined') {
              branding = uidDataToInit.branding
            }

            commit('SET_LOGIN_USER', {
              authID: payload.user.uid,
              firstName: uidDataToInit.firstName,
              lastName: uidDataToInit.lastName,
              contactNumber: uidDataToInit.contactNumber,
              clientNameIfAgencyClient: typeof uidDataToInit.clientName === 'undefined' ? false : uidDataToInit.clientName,
              emailAddress: uidDataToInit.emailAddress,
              agency: agencyClients,
              timeSignedUp: typeof data.dateCreated !== "undefined" ? data.dateCreated : false,
              branding: branding,
              agencySplit: typeof data.agencySplit !== "undefined" ? data.agencySplit : false,
              agencyBaseDomain: typeof data.agencyBaseDomain !== "undefined" ? data.agencyBaseDomain : false,
              clientAuthDoc: uidDataToInit,
              agencyEntityDocID: data.entityDocID,
              agencySubscription: typeof data.activeStripeSubscription !== "undefined" ? data.activeStripeSubscription : false,
              agencyName: typeof data.agencyName !== 'undefined' ? data.agencyName : false,
              lastAccessed: typeof data.lastAccessed !== 'undefined' ? data.lastAccessed : false,
              isCollaborator: collaborator ? true : false,
              entityDocID: collaborator ? collaborator : uidDataToInit.entityDocID //if you're a collaborator, we'll load your [docID,docID] as normal
            })

            let goodToGo = true

            /*NOT SURE WHAT THIS DOES?? Why would there be no entityDocID?
            if (Array.isArray(data.entityDocID)) {
              if (data.entityDocID.length === 0) {
                goodToGo = false
              }
            }

            if (!data.entityDocID || data.entityDocID === '') {
              goodToGo = false
            }
            //----------------------*/

            if (goodToGo) {
              resolve(true)
            } else {
              resolve(false)
            }
          }

          
                    //first, determine if this is a collaborator or not
                    if (typeof data.collaborator !== 'undefined') {
                      if (data.collaborator.length > 0) {
                        //this uid has been invited and it has rights

                      continueLogin(data.collaborator)

                    } else {

                      //COLLAB RIGHTS HAVE PROBABLY BEEN REVOKED


                      // This will result in error. Not sure what to do here.

                    }

                    } else {

                      continueLogin(false)

                    }

        } else {
          //console.log('doc not exist')
          //CUSTOMER HAS NOT COMPLETED ANY SETUP
          resolve(false)
        }
      }).catch((e) => {
        console.log(e)
        reject('Error in db auth')
      })
    })


  },
  'REMOVE_CLIENT' ({
    commit,
    state
  }, payload) {

    //noconsoleconsole.log('removing client')
    //noconsoleconsole.log(payload)

    return new Promise((resolve, reject) => {
      return removeClient(payload).then((res) => {
        //noconsoleconsole.log(res)
        resolve(res)
      }).catch((rej) => {
        //noconsoleconsole.log('error from BE:')
        //noconsoleconsole.log(rej)
        reject(rej)
      })
    });
  },
  'CREATE_CUSTOMER_SET_TOKEN_SUBSCRIBE' ({
    commit,
    state
  }, payload) {

    //noconsoleconsole.log('subscribing with payload:')
    //noconsoleconsole.log(payload)

    return new Promise((resolve, reject) => {

      return createCustomerSetTokenSubscribe(payload).then((res) => {
        resolve(res)
      }).catch((rej) => {
        //noconsoleconsole.log('error from BE:')
        //noconsoleconsole.log(rej)
        reject(rej)
      })

    });


  },
  'INVITE_VIA_TEXT' ({
    commit,
    state
  }, payload) {

    //noconsoleconsole.log('subscribing with payload:')
    //noconsoleconsole.log(payload)

    return new Promise((resolve, reject) => {

      return inviteViaText(payload).then((res) => {
        resolve(res)
      }).catch((rej) => {
        //noconsoleconsole.log('error from BE:')
        //noconsoleconsole.log(rej)
        reject(rej)
      })

    });
  },
  'INVITE_VIA_EMAIL' ({
    commit,
    state
  }, payload) {

    //noconsoleconsole.log('subscribing with payload:')
    //noconsoleconsole.log(payload)

    return new Promise((resolve, reject) => {

      return inviteViaEmail(payload).then((res) => {
        resolve(res)
      }).catch((rej) => {
        //noconsoleconsole.log('error from BE:')
        //noconsoleconsole.log(rej)
        reject(rej)
      })

    });
  },  
  'UPDATE_OPEN_GRAPH' ({
    state,
  }, payload) {

    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/updateopengraph', {
          bid: state.viewData.business.businessID,
          opengraph: payload
        }, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          //noconsoleconsole.log(res)
          resolve()
        }).catch((e) => {
          //noconsoleconsole.log(e)
          reject()
        })
      }).catch((e) => {
        //noconsoleconsole.log(e)
        reject(e)
      })
    })

  },
  // ---------------- BYO SENDING (SMTP email / Twilio SMS) ----------------
  // Same token-header + bid-body pattern as the referral calls. Secrets only travel
  // dashboard -> backend on save; the GET returns masked settings (has-password booleans,
  // last-4 accountSid) — never plaintext.
  'FETCH_SENDING_SETTINGS' ({ state }) {
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/getsendingsettings', {
          bid: state.viewData.business.businessID
        }, {
          headers: { token: token, 'Content-Type': 'application/json' }
        }).then((res) => {
          resolve(res.data)
        }).catch((e) => { reject(e) })
      }).catch((e) => { reject(e) })
    })
  },
  // payload: { email?: {...incl optional password}, text?: {...incl optional authToken} }
  'UPDATE_SENDING_SETTINGS' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/updatesendingsettings', {
          bid: state.viewData.business.businessID,
          ...payload
        }, {
          headers: { token: token, 'Content-Type': 'application/json' }
        }).then((res) => {
          resolve(res.data)
        }).catch((e) => { reject(e) })
      }).catch((e) => { reject(e) })
    })
  },
  // payload: { toEmail } — resolves {success, error?, detail?}; send failures resolve (not
  // reject) so the page can show the raw provider error next to the test button
  'SEND_TEST_EMAIL' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/sendtestemail', {
          bid: state.viewData.business.businessID,
          toEmail: payload.toEmail
        }, {
          headers: { token: token, 'Content-Type': 'application/json' }
        }).then((res) => {
          resolve(res.data)
        }).catch((e) => { reject(e) })
      }).catch((e) => { reject(e) })
    })
  },
  // payload: { toNumber } (E.164)
  'SEND_TEST_SMS' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/sendtestsms', {
          bid: state.viewData.business.businessID,
          toNumber: payload.toNumber
        }, {
          headers: { token: token, 'Content-Type': 'application/json' }
        }).then((res) => {
          resolve(res.data)
        }).catch((e) => { reject(e) })
      }).catch((e) => { reject(e) })
    })
  },
  // ---------------- REFERRALS ----------------
  // All referral calls follow the UPDATE_LOOK_AND_FEEL pattern: Firebase ID token in the
  // `token` header + selected `bid` in the body. The dashboard Cloud Run service authorizes
  // the bid against the caller's UID (owner / collaborator / agency).
  'FETCH_REFERRALS' ({ state }) {
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/referrallist', {
          bid: state.viewData.business.businessID
        }, {
          headers: { token: token, 'Content-Type': 'application/json' }
        }).then((res) => {
          resolve(res.data)
        }).catch((e) => { reject(e) })
      }).catch((e) => { reject(e) })
    })
  },
  'UPDATE_REFERRAL_SETTINGS' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/referralupdatesettings', {
          bid: state.viewData.business.businessID,
          settings: payload.settings
        }, {
          headers: { token: token, 'Content-Type': 'application/json' }
        }).then((res) => {
          resolve(res.data)
        }).catch((e) => { reject(e) })
      }).catch((e) => { reject(e) })
    })
  },
  'CREATE_REFERRAL' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/referralcreate', {
          bid: state.viewData.business.businessID,
          referrerName: payload.referrerName,
          referrerEmail: payload.referrerEmail,
          friendName: payload.friendName,
          friendEmail: payload.friendEmail,
          friendPhone: payload.friendPhone,
          clientRequestId: payload.clientRequestId
        }, {
          headers: { token: token, 'Content-Type': 'application/json' }
        }).then((res) => {
          resolve(res.data)
        }).catch((e) => { reject(e) })
      }).catch((e) => { reject(e) })
    })
  },
  'CONFIRM_REFERRAL' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/referralconfirm', {
          bid: state.viewData.business.businessID,
          referralId: payload.referralId,
          action: payload.action // 'confirm' | 'reject'
        }, {
          headers: { token: token, 'Content-Type': 'application/json' }
        }).then((res) => {
          resolve(res.data)
        }).catch((e) => { reject(e) })
      }).catch((e) => { reject(e) })
    })
  },
  'SET_REFERRAL_LEAD_STATUS' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/referralsetleadstatus', {
          bid: state.viewData.business.businessID,
          referralId: payload.referralId,
          leadStatus: payload.leadStatus // 'new' | 'contacted' | 'converted' | 'not_interested'
        }, {
          headers: { token: token, 'Content-Type': 'application/json' }
        }).then((res) => {
          resolve(res.data)
        }).catch((e) => { reject(e) })
      }).catch((e) => { reject(e) })
    })
  },
  'LOOKUP_REFERRAL_CODE' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/referrallookupcode', {
          bid: state.viewData.business.businessID,
          code: payload.code
        }, {
          headers: { token: token, 'Content-Type': 'application/json' }
        }).then((res) => {
          resolve(res.data)
        }).catch((e) => { reject(e) })
      }).catch((e) => { reject(e) })
    })
  },
  // GROUP REFERRALS Phase 5 — mint a personal referral link for an influencer/partner from
  // the dashboard (spec Decision 11). Resolves { success, token, url, reused }.
  'CREATE_REFERRAL_LINK' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/referrallinkcreate', {
          bid: state.viewData.business.businessID,
          name: payload.name,
          email: payload.email
        }, {
          headers: { token: token, 'Content-Type': 'application/json' }
        }).then((res) => {
          resolve(res.data)
        }).catch((e) => { reject(e) })
      }).catch((e) => { reject(e) })
    })
  },
  'MARK_REFERRAL_CODE_USED' ({ state }, payload) {
    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/referralmarkused', {
          bid: state.viewData.business.businessID,
          code: payload.code,
          used: typeof payload.used === 'undefined' ? true : payload.used
        }, {
          headers: { token: token, 'Content-Type': 'application/json' }
        }).then((res) => {
          resolve(res.data)
        }).catch((e) => { reject(e) })
      }).catch((e) => { reject(e) })
    })
  },
  'UPDATE_LOOK_AND_FEEL' ({
    state,
  }, payload) {

    return new Promise((resolve, reject) => {
      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/updatelookandfeel', {
          bid: state.viewData.business.businessID,
          appearanceinfo: typeof payload.appearanceInfo === 'undefined' ? false : payload.appearanceInfo,
          feedbackaddresshandle: payload.feedbackAddressHandle
        }, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          //noconsoleconsole.log(res)
          resolve()
        }).catch((e) => {
          //noconsoleconsole.log(e)
          reject()
        })
      }).catch((e) => {
        //noconsoleconsole.log(e)
        reject(e)
      })
    })

  },
  'SYNC_INVITE_SENT_HISTORY' ({
    commit,
    state
  }, payload) {

    /*
      type
      startAfter: false or docID
    */
  
    return new Promise((resolve, reject) => {

      auth.currentUser.getIdToken().then((token) => { 
        axios.post(dashURLBase + '/api/dash/fetchinvites', {
          bID: state.viewData.business.businessID,
          type: payload.type,
          startAfter: payload.startAfter
        }, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((data) => {
          data = data.data             
          commit('SET_INVITE_HISTORY', {
            target: payload.type,
            docs: data.returnInvites,
            startAfter: payload.startAfter
          })
          resolve(data.hasMore)
        }).catch((e) => {
          console.log(e)
          reject(false)
        })            
      })   

    })

  },

      /*
      //noconsoleconsole.log('getting stuff')

      let entityRef = db.collection('entities').doc(state.viewData.business.businessID).collection(target + 'inviterecord').orderBy("dateSent", "desc").onSnapshot((docs) => {

        if (!docs.empty) {
          let docsAr = []

          docs.forEach((docco) => {

            let doccoData = docco.data()
            if (Array.isArray(doccoData.to)) {
              if (doccoData.to.length > 1) {
                doccoData.to.forEach((numberSent) => {
                  docsAr.push({
                    dateSent: doccoData.dateSent,
                    to: numberSent,
                    triggeredBy: typeof doccoData.whoSent !== 'undefined' ? doccoData.whoSent : false
                  })
                })
              } else {
                docsAr.push({
                  dateSent: doccoData.dateSent,
                  to: doccoData.to[0],
                  triggeredBy: typeof doccoData.whoSent !== 'undefined' ? doccoData.whoSent : false
                })
              }
            } else {
              docsAr.push({
                dateSent: doccoData.dateSent,
                to: doccoData.to,
                triggeredBy: typeof doccoData.whoSent !== 'undefined' ? doccoData.whoSent : false
              })
            }

          })

          commit('SET_INVITE_HISTORY', {
            target,
            docs: docsAr
          })
          resolve()

        } else {

          commit('SET_INVITE_HISTORY', {
            target,
            docs: []
          })
          resolve()

        }
      })

      */
  
  'UPDATE_SHARING_AND_REVIEWS' ({
    commit,
    state,
    dispatch
  }, payload) {
    return new Promise((resolve, reject) => {

      let batch = db.batch()

      let entityRef = db.collection('entities').doc(state.viewData.business.businessID)
      //let publicRef = db.collection('feedbackpublic').doc(state.viewData.business.businessID)

      /*let publicDoc = {
        socialMedia: payload
      }*/

      //for now,

      let entityDoc = {}

      //entityDoc['publicFeedbackDetail.negativeShareReview'] = payload.negativeShareReview
      //entityDoc['publicFeedbackDetail.socialMedia'] = payload.socialMedia

      /*
      Loop through platforms
      If the platform was === false and now not empty, set it to new platform obj

      ALSO

      If the platform was === false and now not empty
        add it for Datashake crawl
      If the platform was !== false and now not empty
        If the platform url !== the old platform url
          Add it for datashake crawl
      */

      let extPlatforms = state.viewData.business.externalPlatforms

      for (var prop in extPlatforms) {
        if (Object.prototype.hasOwnProperty.call(extPlatforms, prop)) {
          //noconsole.log('checking ' + prop)
          let theString = mapPlatformToPanelString(prop)
          //noconsole.log('string ' + theString)
          //noconsole.log('value ' + payload.socialMedia[theString])

          if (extPlatforms[prop] === false) {
            if (payload.socialMedia[theString] !== '') {
              //NEW, ADD TO DATASHAKE crawl              
              if (prop !== 'tw') {
                //noconsoleconsole.log(prop + ' new, adding for scrape with id: ' + payload.socialMedia[theString])
                dispatch('ADD_PROFILE_FOR_REVIEWS_SCRAPE', {
                  platform: prop,
                  id: prop === 'gp' ? payload.socialMedia[theString].place_id : payload.socialMedia[theString]
                })
              }
              //update the entity object
              entityDoc['externalPlatforms.' + prop] = returnNewPlatform((prop === 'gp' ? payload.socialMedia[theString].place_id : payload.socialMedia[theString]))
              if (prop === 'gp') {
                entityDoc['externalPlatforms.' + prop + '.gpObject'] = payload.socialMedia[theString]
              }
            }
          } else {
            if (payload.socialMedia[theString] !== '') {
              if (extPlatforms[prop].id !== (prop === 'gp' ? payload.socialMedia[theString].place_id : payload.socialMedia[theString])) {
                //noconsoleconsole.log(prop + ' changed , adding for scrape with id: ' + payload.socialMedia[theString])
                //CHANGED, ADD TO DATASHAKE crawl
                if (prop !== 'tw') {

                  //just incase there was a previous error:
                  entityDoc['externalPlatforms.' + prop + '.error'] = false
                  entityDoc['externalPlatforms.' + prop + '.reason'] = false
                  entityDoc['externalPlatforms.' + prop + '.noReviews'] = false

                  dispatch('ADD_PROFILE_FOR_REVIEWS_SCRAPE', {
                    platform: prop,
                    id: prop === 'gp' ? payload.socialMedia[theString].place_id : payload.socialMedia[theString]
                  })
                }

                //UPDATE THE ENTITY DOC
                entityDoc['externalPlatforms.' + prop + '.id'] = (prop === 'gp' ? payload.socialMedia[theString].place_id : payload.socialMedia[theString])
                if (prop === 'gp') {
                  entityDoc['externalPlatforms.' + prop + '.gpObject'] = payload.socialMedia[theString]
                }
              }
            } else {
              //it's empty, null and void it
              entityDoc['externalPlatforms.' + prop] = false
            }
          }
        }
      }


      batch.update(entityRef, entityDoc)
      //batch.set(publicRef, publicDoc, {merge: true})

      batch.commit().then(() => {
        resolve()
      }).catch((e) => {
        //noconsoleconsole.log(e)
        reject(e)
      })
    })
  },
  'UPDATE_EMAIL_SETTINGS' ({
    state,
  }, payload) {

    return new Promise((resolve, reject) => {
      db.collection('entities').doc(state.viewData.business.businessID).update({
        emailSettings: {...payload}
      }).then(() => {
        resolve()
      }).catch(() => {
        reject()
      })
    })

  },
  //SMS followups — exact mirror of UPDATE_EMAIL_SETTINGS onto textSettings
  'UPDATE_TEXT_SETTINGS' ({
    state,
  }, payload) {

    return new Promise((resolve, reject) => {
      db.collection('entities').doc(state.viewData.business.businessID).update({
        textSettings: {...payload}
      }).then(() => {
        resolve()
      }).catch(() => {
        reject()
      })
    })

  },
  'UPDATE_RESPONSE' ({
    commit,
    state,
  }, payload) {

    return new Promise((resolve, reject) => {

      auth.currentUser.getIdToken().then((token) => { 
        axios.post(dashURLBase + '/api/dash/updateResponse', {
          bID: state.viewData.business.businessID,
          ...payload
        }, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((data) => {
          
          commit('UPDATE_RESPONSE', {...payload})

          resolve()
        }).catch((e) => {
          console.log(e)
          reject()
        })            
      })   

    })

  },
  'UPDATE_BUSINESS_INFORMATION' ({
    commit,
    state,
  }, payload) {
    return new Promise((resolve, reject) => {

      let batch = db.batch()

      let entityRef = db.collection('entities').doc(state.viewData.business.businessID)
      //let publicRef = db.collection('feedbackpublic').doc(state.viewData.business.businessID)

      let entityDoc = {
        businessName: payload.businessInfo.businessName,
        'businessInfo': {
          businessContact: payload.businessInfo.businessContact,
          businessEmail: payload.businessInfo.businessEmail,
          webAddress: payload.businessInfo.webAddress,
          businessName: payload.businessInfo.businessName
        },
        'publicFeedbackDetail.entityInfo': {
          businessContact: payload.businessInfo.businessContact,
          businessEmail: payload.businessInfo.businessEmail,
          webAddress: payload.businessInfo.webAddress,
          businessName: payload.businessInfo.businessName
        }
      }

      /*let publicDoc = {
        entityInfo: {
          businessContact: payload.businessInfo.businessContact,
          businessEmail: payload.businessInfo.businessEmail,
          webAddress: payload.businessInfo.webAddress,
          businessName: payload.businessInfo.businessName
        }
      }*/

      batch.update(entityRef, entityDoc)
      //batch.update(publicRef, publicDoc)

      batch.commit().then(() => {
        resolve()
      }).catch((e) => {
        //noconsoleconsole.log(e)
        reject()
      })
    })
  },
  'UPDATE_BUSINESS_ENTITY' ({
    commit,
    state,
  }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('entities').doc(state.viewData.business.businessID).update(payload).then(() => {
        resolve()
      }).catch((e) => {
        //noconsoleconsole.log(e)
        reject()
      })
    })
  },
  'SYNC_EXTERNAL_LINKS' ({
    commit,
    state,
  }, payload) {
    return new Promise((resolve, reject) => {

      let entityRef = db.collection('entities').doc(state.viewData.business.businessID)

      let updateDoc = {
        'publicFeedbackDetail.externalLinks': payload
      }

      entityRef.update(updateDoc).then(() => {
        resolve()
      }).catch((e) => {
        //noconsoleconsole.log(e)
        reject(e)
      })
    })
  },
  'REMOVE_MULTI_LOCATION' ({
    state
  }, payload) {

    return new Promise((resolve, reject) => {
      removeMultiLocation({
        locationUID: payload.locationUID,
        clientID: typeof payload.isClientLocation !== "undefined" ? payload.isClientLocation : false
      }).then((res) => {
        resolve(res)
      }).catch(() => {
        //noconsoleconsole.log(e)
        reject()
      })
    })

  },
  'GET_ANALYTICS' ({
    commit,
    state,
    rootState
  }, payload) {

    return new Promise((resolve, reject) => {

      auth.currentUser.getIdToken().then((token) => {
        axios.post(npsApiURL, {
          bID: payload.bID,
          target: payload.target
        }, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((res) => {

          let dta = res.data
          /*{
            nps: ..,
            csat: ..,
            star: ..
          }
          object now returns divided into NPS, CSAT and Star
          */

          commit('LOAD_ANALYTICS', {
            target: dta.target,
            nps: dta.nps,
            csat: dta.csat,
            star: dta.star
          })

          //noconsoleconsole.log(res)
          
        }).catch((res) => {
          //noconsoleconsole.log(res)
          reject()
        })
      }).catch((e) => {
        //noconsoleconsole.log(e)
      })

    })


  },
  'UPDATE_LANGUAGE' ({
    commit,
    state
  }, payload) {


    //THIS FUNCTION IS DUE FOR A CLOUD RUN UPGRADE!


    //noconsoleconsole.log(payload)
    return new Promise((resolve, reject) => {

      let batch = db.batch()

      let entityRef = db.collection('entities').doc(state.viewData.business.businessID)

      let toPush = {}

      if (!payload.translation.isCustom) {
        //its a change to an official language, so update just to the language
        toPush.language = payload.translation.language
      } else {
        //its a custom language, so update THAT language pack
        toPush.customLanguagePacks = typeof state.viewData.business.customLanguagePacks !== "undefined" ? state.viewData.business.customLanguagePacks : {}
        toPush.customLanguagePacks[payload.translation.language] = payload.translation
        toPush.language = payload.translation.language
      }

      batch.update(entityRef, toPush)

      if (state.isMulti) {

        let toPushMulti = {}
        if (payload.translation.isCustom) {

          //we always sync the actual packs accross
          toPushMulti.customLanguagePacks = typeof state.viewData.business.customLanguagePacks !== "undefined" ? state.viewData.business.customLanguagePacks : {}
          toPushMulti.customLanguagePacks[payload.translation.language] = payload.translation

          //but only apply it to other multies if asked
          if (payload.allMulties) toPushMulti.language = payload.translation.language

        } else {
          if (payload.allMulties) toPushMulti.language = payload.translation.language
        }

        state.multiLocations.forEach((location) => {
          if (location.businessID !== state.viewData.business.businessID) {
            batch.update(db.collection('entities').doc(location.businessID), toPushMulti)
          }
        })

      }


      batch.commit().then(() => {
        resolve()
      }).catch((e) => {
        //noconsoleconsole.log(e)
        reject()
      })
    })
  },
  'LOAD_OFFICIAL_LANGUAGES' ({
    commit,
    state
  }) {

    return new Promise((resolve, reject) => {

      db.collection('languagepacks').get().then((docs) => {
        if (!docs.empty) {
          let toCommit = []
          docs.docs.forEach(function(doc, i) {
            toCommit.push(doc.data())
          })
          commit('SET_LANGUAGE_PACKS', toCommit)
          resolve()
        } else {
          reject()
        }
      }).catch((e) => {
        //noconsoleconsole.log(e)
        reject()
      })


    })

  },
  'GET_MULTI_ENTITIES_INFO' ({
    commit,
    state
  }) {


    // fetch all other entities that this uid has access to
    // (for this brand)

    console.log('getting multis info')

      return new Promise((resolve, reject) => {

        auth.currentUser.getIdToken().then((token) => {
          axios.post(dashURLBase + '/api/dash/getmultisinfo', {
            bid: state.viewData.business.businessID
          }, {
            headers: {
              token: token,
              'Content-Type': 'application/json'
            }
          }).then((res) => {
            //noconsole.log('other multis:')
            
            commit('ADD_ADDITIONAL_MULTI_LOCATIONS', res.data)

            resolve()
          }).catch((res) => {
            //noconsole.log(res)
            reject()
          })
        }).catch((e) => {
          //noconsole.log(e)
          //reject()
        })

      })

  },
  'GET_ENTITY' ({
    commit,
    state,
    dispatch
  }, payload) {
    
    return new Promise(async (resolve, reject) => {
      
    
      //1. Determine which entity to load

      //start with entities this user has access to:
      let entityDocIDs = state.loggedInUser.entityDocID
      if (!Array.isArray(entityDocIDs)) {
        entityDocIDs = [entityDocIDs]
      }

      let eIDToInit = entityDocIDs[0]

      if (payload.viewBusiness) {
        //requested a specific entity
        if (entityDocIDs.includes(payload.viewBusiness)) {
          eIDToInit = payload.viewBusiness
        }
      } 
      

      //2. Load that entity, and init state

      try {
        
        const doc = await db.collection('entities').doc(eIDToInit).onSnapshot(
          (doc) => {
            if (doc.exists) {
  
              const data = doc.data()
            
              const payloadToPass = {}
              
              payloadToPass.busData = data
    
              if (typeof payloadToPass.busData.isAppSumo === "undefined") {
                payloadToPass.busData.isAppSumo = false
              }
    
              if (entityDocIDs.length > 1) {
                
                payloadToPass.isMulti = true
                //noconsoleconsole.log('ACTION: new data, target:' + target)
                payloadToPass.noLocations = entityDocIDs.length
                
                //trigger a call to collect info about the other entities:
                dispatch('GET_MULTI_ENTITIES_INFO')
    
              } else {
    
                payloadToPass.isMulti = false
    
              }                
    
              //check if this entity is still on trial
              payloadToPass.isTrialOver = false
              let trialDetails = checkIsTrialOver(data)
              if (trialDetails.isTrial) {            
                if (trialDetails.daysLeft < 0) {
                  payloadToPass.isMulti = false
                  payloadToPass.isTrialOver = true
                }
              }
    
              commit('SET_BUSINESS_STATE', payloadToPass)
              
              //can resolve multiple times, will not re-resolve to the callers
              resolve()              
    
            } 
          }
        )

      } catch (e) {
        
        //i probably don't have permissionss
        //What to do ???
        console.log(e)
        reject()


      }
      


      /*


      


      //start syncing each business doc one by one, resolve after all has been synced


      let fetchAndSyncBusiness = (entityDocs, target) => {

        //noconsoleconsole.log('SYNCING ENTITY:' + entityDocs[target])

        db.collection('entities').doc(entityDocs[target]).onSnapshot((doc) => {
          if (doc.exists) {
            
            
            const data = doc.data()
            //noconsole.log('setting business state with:')
            const payloadToPass = {}
            payloadToPass.busData = data

            if (typeof payloadToPass.busData.multi !== 'undefined' && entityDocs.length === 1) {
              //MULTI LOCATIONS BUT I ONLY HAVE ACCESS TO THIS ONE, LIMIT MY SHIT I CAN DO!!
            }

            if (typeof payloadToPass.busData.isAppSumo === "undefined") {
              payloadToPass.busData.isAppSumo = false
            }

            if (entityDocs.length > 1) {
              payloadToPass.isMulti = true
              //noconsoleconsole.log('ACTION: new data, target:' + target)
              payloadToPass.target = target
              payloadToPass.noLocations = entityDocs.length
            } else {
              payloadToPass.isMulti = false
            }

            if (typeof payloadToPass.busData.publicFeedbackDetail.negativeShareReview === 'undefined') {
              payloadToPass.busData.publicFeedbackDetail.negativeShareReview = false
            }

            if (typeof payloadToPass.busData.showcase.clickedInstall === 'undefined') {
              payloadToPass.busData.showcase.clickedInstall = false
            }



            //ONLY RESOLVE IF THIS IS INITIAL LOAD
            if (target + 1 === entityDocs.length && !state.allEntitiesLoaded) {
              resolve()
            }

            payloadToPass.isTrialOver = false

            let trialDetails = checkIsTrialOver(data)
            if (trialDetails.isTrial) {
              //noconsoleconsole.log(trialDetails.daysLeft)
              if (trialDetails.daysLeft < 0) {
                payloadToPass.isMulti = false
                payloadToPass.isTrialOver = true
              }
            }

            commit('SET_BUSINESS_STATE', payloadToPass)

          } else {
            reject(new Error('Entity doc doesnt exist'))
          }


        })
      }



      let target = 0
      entityDocIDs.forEach((eDI) => {
        //noconsole.log('inside loop')
        fetchAndSyncBusiness(entityDocIDs, target)
        target++
      })


      */


    })
  },
  'SET_LAST_ACCESSED' (context, payload) {

    auth.currentUser.getIdToken().then((token) => {
      axios.post(dashURLBase + '/api/dash/setlastaccessed', {}, {
        headers: {
          token: token,
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        //noconsoleconsole.log('last accessed set')
        //noconsole.log(dta)
        //resolve()
      }).catch((res) => {
        //noconsole.log(res)
        //reject()
      })
    }).catch((e) => {
      //noconsole.log(e)
      //reject()
    })
  },
  'QUERY_FEEDBACK' ({
    commit,
    state,
    dispatch
  }, payload) {

    /*


    This action automatically checks based on the current filters, and pull accordingly, 
    unless told NOT to in the payload.

    payload:
    {

      isInitialFetch: bool,
      Is this the first time the dash is loading?
      
      forceStartAfter: true
      DONT disregard period filters, even if user hasn't changed them. 
      This is used when pagination is clicked.

    }

    */
    const requestData = {}
    
    if (!payload.isInitialFetch) {

      //its not the FIRST load, enable filters:
      
      //requestData.startAfter = false //if this is extension, doc ID of last doc
      const currentFilters = state.viewState.viewResponseFilters
      const currentFilterPageData = currentFilters.page

      //paging buttons will send 'true'
      const forceStartAfter = typeof payload.forceStartAfter !== 'undefined' ? payload.forceStartAfter : false

      requestData.timeFromS = false
      requestData.timeToS = false

      if (currentFilters.periodWasChanged && currentFilters.startTime !== null && currentFilters.endTime !== null) {
        requestData.timeFromS = Math.floor(currentFilters.startTime / 1000)
        requestData.timeToS = Math.floor(currentFilters.endTime / 1000)
      }      

      requestData.sentiment = []
      
      if (currentFilters.showPositive) requestData.sentiment.push('positive')
      if (currentFilters.showNeutral) requestData.sentiment.push('neutral')
      if (currentFilters.showNegative) requestData.sentiment.push('negative')
      if (currentFilters.showNoRating) requestData.sentiment.push('norating')
      if (currentFilters.showSpam) requestData.showSpam = true
      if (currentFilters.text) requestData.filterWords = currentFilters.text.trim()
      if (currentFilters.questionID) requestData.questionID = currentFilters.questionID
      
      requestData.disregardPeriod = !currentFilters.periodWasChanged 
      
      if (currentFilters.showOnlyAnswers.length > 0 && currentFilters.questionID) {                

        //MANUAL filtering on backend, pass startAfter as an INDEX
        requestData.showOnlyAnswers = currentFilters.showOnlyAnswers          
        if (currentFilters.periodWasChanged || forceStartAfter && currentFilterPageData.index !== 0) 
          requestData.startAfter = currentFilterPageData.index * currentFilterPageData.perPage

      } else if (forceStartAfter && !(currentFilters.showOnlyAnswers.length === 0 && currentFilters.questionID)) {
 
        //FIRESTORE filtering on backend, pass startAfter as a doc ID if necessary        
        const curCollection = state.viewData.viewFeedback
        if (currentFilters.periodWasChanged || forceStartAfter && currentFilterPageData.index !== 0) {
          //only relevant if there is an actual collection:
          if (curCollection.length > 0) {
            requestData.startAfter = curCollection[curCollection.length - 1].sessionID
          }          
        }          

      }
  
      if (requestData.timeFromS === requestData.timeToS && requestData.timeToS && requestData.timeFromS) {
        //fix for the filter UI comp functionality.
        requestData.timeToS = requestData.timeFromS + (24 * 60 * 60)
      }
    
    }

    requestData.isInitialFetch = payload.isInitialFetch

    //reset question results          
    commit('SET_QUESTION_RESULTS', false)        

    //reset collection data
    commit('SET_RESPONSES', [])

    return new Promise((resolve, reject) => {

      commit('LOADING_FEEDBACK')
      //noconsoleconsole.log('querying feedback:')
      //noconsoleconsole.log(requestData)

      auth.currentUser.getIdToken().then((token) => {
        axios.post(dashURLBase + '/api/dash/fetchfeedback', {
          bID: state.viewData.business.businessID,
          ...requestData
         }, {
          headers: {
            token: token,
            'Content-Type': 'application/json'
          }
        }).then((data) => {

        data = data.data
        const collection = data.collection        

        if (collection.length === 0 && data.isInitialFetch) {
          const time = new Date().getTime()
          commit('CHANGE_VIEW_FILTER', {filter: 'endTime', value: time})
          commit('CHANGE_VIEW_FILTER', {filter: 'startTime', value: time})            
          commit ('SET_FEEDBACK_EMPTY')
        }

          const modifiedCollection = []

          collection.forEach(function(doc, i) {

            let seshData = doc                    

            //add a prop to sesh, because Vue needs it to be
            //there from the start to be reactive
            if (typeof seshData.showAllInView === 'undefined') {
              seshData.showAllInView = false
            }            

            seshData.journeyFeedback.forEach((item, i) => {
              
              //for showcase
              item.i = i

              //compatibility fix for phase 0 single/multi Q's
              if (item.type === 'multiq' || item.type === 'singleq') {                
                if (typeof item.answerOptions[0] !== 'object') {
                  const newAnswerOptions = []
                  item.answerOptions.forEach((aO) => {
                    newAnswerOptions.push({
                      text: aO,
                      description: ''
                    })
                  })
                  item.answerOptions = newAnswerOptions
                }                
              }


              //compatibility fix for phase 0 open Qs
              if (item.type === 'openq') {
                if (item.answer) {
                  if (typeof item.answer !== 'object') 
                    item.answer = {
                      textAnswer: item.answer,
                      videoURLAnswer: false
                    }
                }
              }

              //compatibility fix for phase 0 contact Qs
              if (item.type === 'contactq') {
                if (item.answer) {
                  if (typeof item.answer.contact !== 'undefined') {
                    
                    //old
                    const oldAnswer = item.answer
                    const validEmail = validateEmail(oldAnswer.contact)                  

                    const newAnswer = {
                      name: oldAnswer.name,
                      email: validEmail ? oldAnswer.contact : '',
                      
                      //temporary field for dashboard
                      contact: validEmail ? '' : oldAnswer.contact,
                      //temporary field for dashboard

                      jobTitle: '',
                      company: ''

                      /*  
                      name: string,
                      email: string,
                      company: string | false,
                      profilePicture: string | false,
                      jobTitle: string | false
                      */

                    }
                    item.answer = newAnswer
                  }
                }
              }

              //add an 

            });

            modifiedCollection.push(seshData)

          })



          console.log('responses received:')
          console.log(modifiedCollection)          
        
          commit('SET_RESPONSES', modifiedCollection)

          if (typeof requestData.startAfter === 'undefined') {
            //there was no 'start after' sent in request, which in turn means this is page 0
            //which means reset the index to 0
            commit('CHANGE_PAGE_VIEW_FILTER', {
              filter: 'index',
              value: 0
            })
          }

          if (data.questionResults) {
            commit ('SET_QUESTION_RESULTS', data.questionResults)
          }          
        
            commit('CHANGE_PAGE_VIEW_FILTER', {
              filter: 'hasMore',
              value: data.hasMore
            })     

          if (data.isInitialFetch) {
            //load filterable questions into store
            commit('CHANGE_QUESTIONS_WITH_RESPONSES', data.filterableQuestions)
          }

          /* THE BACKEND NEVER CHANGES THE FILTER.
          if (collection.length !== 0 && data.disregardPeriod) {                                                 
            commit('CHANGE_VIEW_FILTER', {filter: 'endTime', value: data.timeToS * 1000})
            commit('CHANGE_VIEW_FILTER', {filter: 'startTime', value: data.timeFromS * 1000})
          }*/

          resolve()
      
        commit('FEEDBACK_LOADED')

        //OFFICIALY RECORD THAT FEEDBACK HAS BEEN CHECKED FOR AND if any, LOADED
        if (!state.viewState.initialFeedbackLoaded) {
          commit('SET_INITIAL_FEEDBACK_LOADED')
        }

      })

    }).catch((e) => {
      reject(e)
      //noconsoleconsole.log(e)
    })
    })
  },
  'MARK_AS_SPAM' ({
    commit,
    state,
    dispatch
  }, payload) {
    return new Promise((resolve, reject) => {

      //1. mark item in viewFeedback as spam
      //2. update the DB and mark as spam in background
      //noconsoleconsole.log('marking as spam')

      let dbRef = db.collection('feedbackpublic').doc(state.viewData.business.businessID).collection('feedback').doc(payload.sessionID)

      commit('MARK_SESSION_AS_SPAM', {
        sessionID: payload.sessionID
      })

      dbRef.update({
        isSpam: true
      }).then(() => {
        //noconsoleconsole.log('marked in DB as spam')

        dispatch('QUERY_FEEDBACK', {isInitialFetch: false})

        resolve()
      }).catch(() => {
        reject()
      })
    })
  },
  'UNMARK_AS_SPAM' ({
    commit,
    state,
    dispatch
  }, payload) {
    return new Promise((resolve, reject) => {

      //1. mark item in viewFeedback as spam
      //2. update the DB and mark as spam in background
      //noconsoleconsole.log('marking as spam')

      commit('UNMARK_SESSION_AS_SPAM', {
        sessionID: payload.sessionID
      })

      let dbRef = db.collection('feedbackpublic').doc(state.viewData.business.businessID).collection('feedback').doc(payload.sessionID)

      dbRef.update({
        isSpam: false
      }).then(() => {
        //noconsoleconsole.log('unmarked in DB as spam')
        dispatch('QUERY_FEEDBACK', {isInitialFetch: false})
        resolve()
      }).catch(() => {
        reject()
      })

    })
  },
  /*'REMOVE_FROM_LIST' ({
    commit,
    state
  }, payload) {
    //noconsoleconsole.log(payload)
    return new Promise((resolve, reject) => {
      let updateObj = {}
      updateObj['_inlist_' + payload.list] = db.FieldValue.delete()
      let inLists = payload.response.inLists
      let index = inLists.indexOf(payload.list)
      if (index > -1) {
        inLists.splice(index, 1)
      }
      updateObj['inLists'] = inLists
      let listList = payload.response.listList
      listList = listList.replace(', ' + payload.listName, '')
      listList = listList.replace(payload.listName + ', ', '')
      listList = listList.replace(payload.listName, '')
      updateObj['listList'] = listList
      let dbRef = db.collection('feedbackpublic').doc(state.viewData.business.businessID).collection('feedback')
      dbRef.doc(payload.response.docID).update(updateObj).then(() => {
        let thisPayload = {
          ...payload,
          newInLists: inLists,
          newListList: listList
        }
        commit('REMOVE_LIST_FROM_STATE_RESPONSE', thisPayload)
        resolve()
      }).catch(() => {
        reject()
      })
    })
  },*/
  'ADD_NEW_QUESTION' ({
    commit,
    state,
    dispatch
  }, payload) {
    return new Promise((resolve, reject) => {

      //noconsoleconsole.log('starting to add question')
      let time = (new Date).getTime()

      let newQuestionID = payload.questionID
      
      let addQBatch = db.batch()

      let entityRef = db.collection('entities').doc(state.viewData.business.businessID).collection('questions').doc(newQuestionID)
      
      const questionData = {
        ...payload,
        timeCreated: time,
        creatorID: state.loggedInUser.authID,
        firstName: state.loggedInUser.firstName,
        lastName: state.loggedInUser.lastName
      }

      addQBatch.set(entityRef, questionData)

      addQBatch.commit().then(() => {
        //noconsoleconsole.log('QUESTION ADDED')
      }).catch((e) => {
        //noconsoleconsole.log(e)
        reject()
      }).finally(() => {
        resolve()
      })
      //resolve()

    })
  },
  'GET_SESSION_RESPONSES' ({
    commit,
    state
  }, sessionID) {
    return new Promise((resolve, reject) => {
      let dbRef = db.collection('feedbackpublic').doc(state.viewData.business.businessID).collection('feedback')
      dbRef.where('sessionID', '==', sessionID).get().then((docs) => {
        let collection = []
        docs.forEach((d) => {
          collection.push(d.data())
        })
        resolve(collection)
      }).catch(() => {
        reject()
      })
    })
  }
}


function returnNewPlatform(id) {
  return {
    id,
    rating: false,
    fetchReviews: true,
    noReviews: false,
    error: false,
    reason: false,
    luID: false,
    last_successful_crawl: false
  }
}

function mapPlatformToPanelString(pf) {
  switch (pf) {
    case 'ca':
      return 'capterra'
      break;
    case 'fs':
      return 'fourSquare'
      break;
    case 'fb':
      return 'facebook'
      break;
    case 'g2':
      return 'g2'
      break;
    case 'gp':
      return 'googleMaps'
      break;
    case 'ta':
      return 'tripAdvisor'
      break;
    case 'tp':
      return 'trustPilot'
      break;
    case 'ye':
      return 'yelp'
    case 'tw':
      return 'twitter'
      break;
  }
}

function validateEmail (email) {
  return Boolean(email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  ))
}